import { useFormContext } from "react-hook-form";
import AddressFormFields from "../../shared/AddressFormFields";

const AddressDetailsContainer = () => {
	const { setValue } = useFormContext();

	const handleGeolocationChange = (
		newLatlon: string,
		georisquesAddress?: {
			streetNumber?: string;
			streetName?: string;
			postalCode?: string;
			city?: string;
		},
	) => {
		setValue("latlon", newLatlon);
		if (georisquesAddress) {
			setValue("georisquesAddress", georisquesAddress);
		}
	};

	return (
		<AddressFormFields
			showBorder={true}
			onGeolocationChange={handleGeolocationChange}
			includeGeolocation={true}
		/>
	);
};

export default AddressDetailsContainer;
